module.exports = __webpack_public_path__ + "static/img/google.bba41c17.png";